import React from 'react';
import { Award, Globe, TrendingDown, Users, Truck, Settings } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';

const iconMap = {
  'award': Award,
  'globe': Globe,
  'trending-down': TrendingDown,
  'users': Users,
  'truck': Truck,
  'settings': Settings
};

const WhyChooseUsSection = ({ reasons }) => {
  return (
    <div className="py-24 bg-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 rounded-full bg-amber-100 text-amber-800 text-sm font-semibold mb-4">
            Why Choose Us
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            Your Trusted Bitumen Partner
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Experience excellence in every aspect of our service
          </p>
        </div>

        {/* Reasons Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => {
            const Icon = iconMap[reason.icon];
            return (
              <Card 
                key={index}
                className="group hover:shadow-2xl transition-all duration-500 border-2 border-slate-100 hover:border-amber-500 bg-white hover:-translate-y-2"
              >
                <CardHeader>
                  <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-amber-100 to-amber-50 flex items-center justify-center mb-4 group-hover:from-amber-600 group-hover:to-amber-700 transition-all duration-300 group-hover:scale-110">
                    <Icon className="w-8 h-8 text-amber-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  <CardTitle className="text-xl font-bold text-slate-900 group-hover:text-amber-600 transition-colors duration-300">
                    {reason.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base text-slate-600 leading-relaxed">
                    {reason.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUsSection;
